export const IDCheck = (value) => {
  // id 체크 정규식 : 숫자, 영문만 입력 가능
  let regExpId = /^[0-9a-z]+$/;
  if(regExpId.test(value)){
    return true;
  } else {
    return false;
  }
}

//한글만 가능 : [ 가나다라 ... ] 주의 : ㄱㄴㄷ... 형식으로는 입력 불가능 , 띄어쓰기 불가능
export const NameCheck = (value) => {
  let regExpname = /^[가-힣]+$/;
  if(regExpname.test(value)){
    return true;
  } else {
    return false;
  }
}

export const PasswordCheck = (value) => { //영문, 숫자만 포함 6자리-20자리
  let regPass1 = /^(?=.*[a-zA-Z])(?=.*[0-9]).{6,20}$/; //영문, 숫자 포함 6자리 이상
  let regPass2 = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g; //특수 문자 체크
  if (regPass1.test(value) && !regPass2.test(value)) {
      return true;
  } else {
      return false;
  }
}

export const EmailCheck = (value) => {
  // 이메일주소 형식 체크 정규식
  let regExpEm = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
  if(regExpEm.test(value)){
    return true;
  } else {
    return false;
  }
}